export default "__VITE_ASSET__CzOuLZwI__"